import {
  Button,
  Col,
  Container,
  Dropdown,
  FloatingLabel,
  Form,
  Placeholder,
  Row,
} from "react-bootstrap";
import { FloatNumericInput, FloatSelect, HeadPage } from "src/componentes";
import TributacaoCfopImpostoIBSCBSCadastroCode from "./TributacaoCfopImpostoIBSCBSCadastro.Code";

const TributacaoCfopImpostoIBSCBSCadastroView = () => {
  const code = TributacaoCfopImpostoIBSCBSCadastroCode();

  const cstSelectOptions = [
    { value: 0, label: "Selecione" },
    ...code.cstOptions.map((c) => ({
      value: c.id,
      label: `${c.cst} - ${c.descricaoCST}`,
    })),
  ];

  const selectedClassificacao = code.classificacaoOptions.find(
    (cl) => cl.cClassTrib === code.form.watch("classificacoesTributarias")
  );

  const documentTypes = selectedClassificacao
    ? [
        { label: "NF-e", value: selectedClassificacao.indNFe },
        { label: "NFC-e", value: selectedClassificacao.indNFCe },
        { label: "CT-e", value: selectedClassificacao.indCTe },
        { label: "CT-e OS", value: selectedClassificacao.indCTeOS },
        { label: "BP-e", value: selectedClassificacao.indBPe },
        { label: "NF3-e", value: selectedClassificacao.indNF3e },
        { label: "NFCom", value: selectedClassificacao.indNFCom },
        { label: "NFS-e", value: selectedClassificacao.indNFSE },
        { label: "NF Agro", value: selectedClassificacao.indNFAg },
        { label: "NF Gás", value: selectedClassificacao.indNFGas },
      ].filter((d) => d.value)
    : [];
  const formatDate = (dateStr: string | null | undefined) => {
    if (!dateStr) return "-";
    const datePart = dateStr.split("T")[0];
    const parts = datePart.split("-");
    if (parts.length === 3) {
      return `${parts[2]}/${parts[1]}/${parts[0]}`;
    }
    return dateStr;
  };
  const classificacaoSelectOptions = [
    { value: "", label: "Selecione" },
    ...code.classificacaoOptions.map((cl) => ({
      value: cl.cClassTrib,
      label: `${cl.cClassTrib} - ${cl.descricaoClassTrib}`,
    })),
  ];

  return (
    <Container>
      <Form noValidate onSubmit={code.form.handleSubmit(code.onSubmit)}>
        <HeadPage headText="IBS/CBS Cadastro">
          {code.menu.menuItens !== undefined &&
            code.menu.menuItens.map((item) => (
              <Dropdown.Item
                key={item.id}
                onClick={code.menu.handleMenuClick(item)}
              >
                {item.nome}
              </Dropdown.Item>
            ))}
        </HeadPage>
        {!code.loading ? (
          <>
            <Row>
              <Col xs={12} sm={6}>
                <FloatSelect
                  label="CST"
                  options={cstSelectOptions}
                  register={code.form.register("cst")}
                  errorsMessage={code.form.formState.errors.cst}
                  tooltipMessage="Código de Situação Tributária para IBS/CBS"
                  onSelect={(value: string | number) =>
                    code.handleCstChange(Number(value))
                  }
                />
              </Col>
              <Col xs={12} sm={6}>
                <FloatSelect
                  label="Classificação Tributária"
                  options={classificacaoSelectOptions}
                  register={code.form.register("classificacoesTributarias")}
                  errorsMessage={
                    code.form.formState.errors.classificacoesTributarias
                  }
                  tooltipMessage="Classificação tributária conforme LC 214/2025"
                  onSelect={(value: string | number) =>
                    code.handleClassificacaoChange(String(value))
                  }
                />
              </Col>
            </Row>

            {selectedClassificacao && (
              <Row className="mt-2 mb-2">
                <Col xs={12}>
                  {/* Badges Row */}
                  {documentTypes.length > 0 && (
                    <div className="d-flex flex-wrap align-items-center gap-2 mb-2">
                      <span className="text-secondary small fw-semibold me-1">Permitido para:</span>
                      {documentTypes.map((doc) => (
                        <span
                          key={doc.label}
                          className="badge bg-info-subtle text-info border border-info-subtle px-2.5 py-1 rounded"
                          style={{ fontSize: "0.78rem" }}
                        >
                          {doc.label}
                        </span>
                      ))}
                    </div>
                  )}

                  {/* Metadata Row */}
                  <div className="row g-2 mt-2 pt-2 border-top small">
                    <div className="col-12 col-sm-4 text-secondary">
                      <strong>Publicação:</strong> {formatDate(selectedClassificacao.publicacao)}
                    </div>
                    <div className="col-12 col-sm-4 text-secondary">
                      <strong>Vigência:</strong> {formatDate(selectedClassificacao.inicioVigencia)} a {selectedClassificacao.fimVigencia ? formatDate(selectedClassificacao.fimVigencia) : "Indeterminada"}
                    </div>
                    {selectedClassificacao.link && (
                      <div className="col-12 col-sm-4 text-secondary">
                        <strong>Legislação:</strong>{" "}
                        <a
                          href={selectedClassificacao.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-info fw-semibold text-decoration-none"
                        >
                          Visualizar Lei ↗
                        </a>
                      </div>
                    )}
                  </div>
                </Col>
              </Row>
            )}

            {code.selectedCst && (
              <>
                {/* IBS - UF Section */}
                <Row className="mt-3">
                  <Col xs={12}>
                    <h6 className="text-secondary">IBS - UF</h6>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} sm={6} md={4}>
                    <FloatNumericInput
                      label="% IBS UF"
                      control={code.form.control}
                      name="percentualUFIBS"
                      errorsMessage={
                        code.form.formState.errors.percentualUFIBS
                      }
                      tooltipMessage="Percentual do IBS atribuído à UF"
                    />
                  </Col>
                  <Col xs={12} sm={6} md={4}>
                    <FloatNumericInput
                      label="% Alíquota Efetiva UF"
                      control={code.form.control}
                      name="percentualUFAliquotaEfetivaIBS"
                      errorsMessage={
                        code.form.formState.errors.percentualUFAliquotaEfetivaIBS
                      }
                      tooltipMessage="Alíquota efetiva do IBS na UF"
                    />
                  </Col>
                  <Col xs={12} sm={6} md={4}>
                    <FloatNumericInput
                      label="% Devolução Tributo UF"
                      control={code.form.control}
                      name="percentualUFDevolucaoTributoIBS"
                      errorsMessage={
                        code.form.formState.errors
                          .percentualUFDevolucaoTributoIBS
                      }
                      tooltipMessage="Percentual de devolução de tributo na UF"
                    />
                  </Col>
                </Row>
                {code.selectedCst.indDif && (
                  <Row>
                    <Col xs={12} sm={6} md={4}>
                      <FloatNumericInput
                        label="% Diferimento UF"
                        control={code.form.control}
                        name="percentualUFDiferimentoIBS"
                        errorsMessage={
                          code.form.formState.errors.percentualUFDiferimentoIBS
                        }
                        tooltipMessage="Percentual de diferimento do IBS na UF"
                      />
                    </Col>
                  </Row>
                )}
                {code.selectedCst.indRedAliq && (
                  <Row>
                    <Col xs={12} sm={6} md={4}>
                      <FloatNumericInput
                        label="% Redução Alíquota UF"
                        control={code.form.control}
                        name="percentualUFReducaoAliquotaIBS"
                        errorsMessage={
                          code.form.formState.errors.percentualUFReducaoAliquotaIBS
                        }
                        tooltipMessage="Percentual de redução da alíquota do IBS na UF"
                      />
                    </Col>
                  </Row>
                )}

                {/* IBS - Município Section */}
                <Row className="mt-3">
                  <Col xs={12}>
                    <h6 className="text-secondary">IBS - Município</h6>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} sm={6} md={4}>
                    <FloatNumericInput
                      label="% IBS Município"
                      control={code.form.control}
                      name="percentualMunicipioIBS"
                      errorsMessage={
                        code.form.formState.errors.percentualMunicipioIBS
                      }
                      tooltipMessage="Percentual do IBS atribuído ao Município"
                    />
                  </Col>
                  <Col xs={12} sm={6} md={4}>
                    <FloatNumericInput
                      label="% Alíquota Efetiva Município"
                      control={code.form.control}
                      name="percentualMunicipioAliquotaEfetivaIBS"
                      errorsMessage={
                        code.form.formState.errors
                          .percentualMunicipioAliquotaEfetivaIBS
                      }
                      tooltipMessage="Alíquota efetiva do IBS no Município"
                    />
                  </Col>
                  <Col xs={12} sm={6} md={4}>
                    <FloatNumericInput
                      label="% Devolução Tributo Município"
                      control={code.form.control}
                      name="percentualMunicipioDevolucaoTributoIBS"
                      errorsMessage={
                        code.form.formState.errors
                          .percentualMunicipioDevolucaoTributoIBS
                      }
                      tooltipMessage="Percentual de devolução de tributo no Município"
                    />
                  </Col>
                </Row>
                {code.selectedCst.indDif && (
                  <Row>
                    <Col xs={12} sm={6} md={4}>
                      <FloatNumericInput
                        label="% Diferimento Município"
                        control={code.form.control}
                        name="percentualMunicipioDiferimentoIBS"
                        errorsMessage={
                          code.form.formState.errors
                            .percentualMunicipioDiferimentoIBS
                        }
                        tooltipMessage="Percentual de diferimento do IBS no Município"
                      />
                    </Col>
                  </Row>
                )}
                {code.selectedCst.indRedAliq && (
                  <Row>
                    <Col xs={12} sm={6} md={4}>
                      <FloatNumericInput
                        label="% Redução Alíquota Município"
                        control={code.form.control}
                        name="percentualMunicipioReducaoAliquotaIBS"
                        errorsMessage={
                          code.form.formState.errors
                            .percentualMunicipioReducaoAliquotaIBS
                        }
                        tooltipMessage="Percentual de redução da alíquota do IBS no Município"
                      />
                    </Col>
                  </Row>
                )}

                {/* CBS Section */}
                <Row className="mt-3">
                  <Col xs={12}>
                    <h6 className="text-secondary">CBS</h6>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} sm={6} md={4}>
                    <FloatNumericInput
                      label="% CBS"
                      control={code.form.control}
                      name="percentualCBS"
                      errorsMessage={
                        code.form.formState.errors.percentualCBS
                      }
                      tooltipMessage="Percentual da Contribuição sobre Bens e Serviços"
                    />
                  </Col>
                  <Col xs={12} sm={6} md={4}>
                    <FloatNumericInput
                      label="% Alíquota Efetiva CBS"
                      control={code.form.control}
                      name="percentualAliquotaEfetivaCBS"
                      errorsMessage={
                        code.form.formState.errors
                          .percentualAliquotaEfetivaCBS
                      }
                      tooltipMessage="Alíquota efetiva da CBS"
                    />
                  </Col>
                  <Col xs={12} sm={6} md={4}>
                    <FloatNumericInput
                      label="% Devolução Tributo CBS"
                      control={code.form.control}
                      name="percentualDevolucaoTributoCBS"
                      errorsMessage={
                        code.form.formState.errors
                          .percentualDevolucaoTributoCBS
                      }
                      tooltipMessage="Percentual de devolução de tributo da CBS"
                    />
                  </Col>
                </Row>
                {code.selectedCst.indDif && (
                  <Row>
                    <Col xs={12} sm={6} md={4}>
                      <FloatNumericInput
                        label="% Diferimento CBS"
                        control={code.form.control}
                        name="percentualDiferimentoCBS"
                        errorsMessage={
                          code.form.formState.errors
                            .percentualDiferimentoCBS
                        }
                        tooltipMessage="Percentual de diferimento da CBS"
                      />
                    </Col>
                  </Row>
                )}
                {code.selectedCst.indRedAliq && (
                  <Row>
                    <Col xs={12} sm={6} md={4}>
                      <FloatNumericInput
                        label="% Redução Alíquota CBS"
                        control={code.form.control}
                        name="percentualReducaoAliquotaCBS"
                        errorsMessage={
                          code.form.formState.errors
                            .percentualReducaoAliquotaCBS
                        }
                        tooltipMessage="Percentual de redução da alíquota da CBS"
                      />
                    </Col>
                  </Row>
                )}

                {/* Crédito Presumido Section */}
                {code.selectedCst.indCredPresIBSZFM && (
                  <>
                    <Row className="mt-3">
                      <Col xs={12}>
                        <h6 className="text-secondary">Crédito Presumido</h6>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12} sm={6} md={4}>
                        <FloatNumericInput
                          label="% Crédito Presumido IBS"
                          control={code.form.control}
                          name="percentualCreditoPresumidoIBS"
                          errorsMessage={
                            code.form.formState.errors
                              .percentualCreditoPresumidoIBS
                          }
                          tooltipMessage="Percentual de crédito presumido do IBS (ZFM)"
                        />
                      </Col>
                      <Col xs={12} sm={6} md={4}>
                        <FloatNumericInput
                          label="% Crédito Presumido CBS"
                          control={code.form.control}
                          name="percentualCreditoPresumidoCBS"
                          errorsMessage={
                            code.form.formState.errors
                              .percentualCreditoPresumidoCBS
                          }
                          tooltipMessage="Percentual de crédito presumido da CBS (ZFM)"
                        />
                      </Col>
                    </Row>
                  </>
                )}
              </>
            )}

            <Row>
              <Col xs={12} className="d-grid mt-3 mb-5">
                <Button type="submit">Confirmar</Button>
              </Col>
            </Row>
          </>
        ) : (
          <Placeholder as={FloatingLabel} animation="glow">
            <Placeholder xs={12} />
          </Placeholder>
        )}
      </Form>
    </Container>
  );
};

export default TributacaoCfopImpostoIBSCBSCadastroView;
